export const profileUpdate = (payload) => {
  return {
    type: 'PROFILE_UPDATE',
    payload,
  };
};

export const setProfile = (payload) => {
  return {
    type: 'SET_PROFILE',
    payload,
  };
};

export const passwordUpdate = (payload) => {
  return {
    type: 'PASSWORD_UPDATE',
    payload,
  };
};

export const loadingUserData = (payload) => {
  return {
    type: 'LOADING_USER_DATA',
    payload,
  };
};

export const getUserData = (payload) => {
  return {
    type: 'GET_USER_DATA',
    payload,
  };
};

export const resetMessage = (payload) => {
  return {
    type: 'RESET_MESSAGE',
    payload,
  };
};

export const updateMessage = (payload) => {
  return {
    type: 'UPDATE_MESSAGE',
    payload,
  };
};

export const tokenError = (payload) => {
  return {
    type: 'TOKEN_ERROR',
    payload,
  };
};

export const serviceError = (payload) => {
  return {
    type: 'SERVICE_ERROR',
    payload,
  };
};
